// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"V_-z","narrowOptionButtons":"W_-z","noOptions":"X_-z"};